import { render, staticRenderFns } from "./GlobalChatbotContainer.vue?vue&type=template&id=06bb01fd&scoped=true"
import script from "./GlobalChatbotContainer.vue?vue&type=script&lang=js"
export * from "./GlobalChatbotContainer.vue?vue&type=script&lang=js"
import style0 from "./GlobalChatbotContainer.vue?vue&type=style&index=0&id=06bb01fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb01fd",
  null
  
)

export default component.exports